import { useNavigate } from "react-router-dom"
import colors from "styles/colors"
import Icon from "./Icon"

function BackBtn({ className, style, onClick }) {
  const navigate = useNavigate()

  return (
    <div className={className} style={style} onClick={() => onClick ? onClick() : navigate(-1)}>
      <Icon
        name="arrow-left"
        bg="circle"
        color="white"
        bgColor={colors.backgroundDark}
        size={36}
        style={{
          boxShadow: `0 0 1rem ${colors.black60}`,
          borderRadius: "50%",
        }}
      />
    </div>
  )
}

export default BackBtn
